export default function isStyledComponent(target) {
    return typeof target === 'object' && 'styledComponentId' in target;
}
//# sourceMappingURL=isStyledComponent.js.map